import { render, staticRenderFns } from "./TableNumberItem.vue?vue&type=template&id=bea8d8ec&scoped=true"
import script from "./TableNumberItem.vue?vue&type=script&lang=js"
export * from "./TableNumberItem.vue?vue&type=script&lang=js"
import style0 from "./TableNumberItem.vue?vue&type=style&index=0&id=bea8d8ec&scoped=true&lang=css"
import style1 from "./TableNumberItem.vue?vue&type=style&index=1&id=bea8d8ec&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea8d8ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bea8d8ec')) {
      api.createRecord('bea8d8ec', component.options)
    } else {
      api.reload('bea8d8ec', component.options)
    }
    module.hot.accept("./TableNumberItem.vue?vue&type=template&id=bea8d8ec&scoped=true", function () {
      api.rerender('bea8d8ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/tableItems/TableNumberItem.vue"
export default component.exports